module.exports = __webpack_public_path__ + "img/drug-19.b7149e1f.png";